import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static values = {
		style: String
	}

	scroll() {
		this.element.nextElementSibling.scrollIntoView()
	}

	goDark() {
		this.styleValue = "dark"
	}

	goLight() {
		this.styleValue = "light"
	}
}
